import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

import { LANGUAGES, type Language } from '../i18n/Language';
import { useLanguage } from '../i18n/LanguageContext';

export const LanguageToggle = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <Tooltip title={t('language.toggle')}>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={language}
        onChange={(_event, next: Language | null) => {
          if (next) setLanguage(next);
        }}
        aria-label={t('language.toggle')}
      >
        {LANGUAGES.map((one) => (
          <ToggleButton key={one} value={one} sx={{ px: 1, py: 0.25, fontSize: 12, fontWeight: 600 }}>
            {one.toUpperCase()}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Tooltip>
  );
};
